var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mt-5 pt-lg-5 term-wrap"
  }, [_c('b-container', {
    staticClass: "mb-5 pb-lg-3"
  }, [_vm.content ? [_c('content-header', {
    attrs: {
      "title": _vm.content.title
    }
  }), _c('div', {
    staticClass: "mt-5"
  }, [_c('p', {
    staticClass: "text-14 text-md-16 term-content",
    domProps: {
      "innerHTML": _vm._s(_vm.content.content)
    }
  })])] : [_c('div', {
    staticClass: "py-5 text-center"
  }, [_c('b-spinner', {
    attrs: {
      "small": "",
      "variant": "platform"
    }
  })], 1)]], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }